import { HelmetDexteel } from "@dexteel/mesf-core";
import { FormProvider } from "./context/formsContext";
import { Forms } from "./Forms";
import { useInitialValues } from "./hooks";
import { useSearchParamsToReducer } from "./hooks/useSearchParamsToReducer";

type Props = {};

export default function FormsIndex(props: Props) {
	useInitialValues();
	useSearchParamsToReducer();
	return (
		<>
			<HelmetDexteel title="Forms" />
			<FormProvider>
				<Forms />
			</FormProvider>
		</>
	);
}
